import {GranularityType} from "../../components/toolsbar/Toolbar";
import {RestDataLoader} from "../widgets/unilever/RestDataLoader";
import {granularityNames, Operativities, OperativityData, OperativityTotals} from "./models";
import {dateToLocalISO, emptyOperativities, fillOperativities} from "./shared";

export async function getDummyOperativityData(from: Date, to: Date, offset: number): Promise<Operativities> {
    return new Promise((res) => {

        const delta = Math.floor((to.getTime() - from.getTime()) / offset);

        const operativities = Array.from<OperativityData>({length: delta}).map((_, i) => {
            return {
                date: new Date(from.getTime() + i * offset),
                value: Math.floor(Math.random() * 100),
            };
        });

        res({
            startDate: from,
            endDate: to,
            operativityGranularity: "",
            operativities,
        });
    });
}

export async function generateFilter(filter: any): Promise<string> {
    return new Promise((res, rej) => {
        RestDataLoader.postJSON(
            "filters/equipment",
            {
                fullFilter: JSON.stringify(filter),
            },
            (response) => {
                res(response.guid as string);
            },
            rej,
        );
    });
}

export async function getOperativity(
    filterGuid: string,
    startDate: Date,
    endDate: Date,
    granularity: GranularityType,
): Promise<Operativities> {
    return new Promise((res, rej) => {
        RestDataLoader.loadData(
            "equipment/filters/" + filterGuid + "/operativity",
            {
                startDate: dateToLocalISO(startDate),
                endDate: dateToLocalISO(endDate),
                granularity: granularityNames[granularity],
            },
            (response: Operativities) => {

                const operativities = fillOperativities(response.operativities, granularity);

                const [firstData] = operativities;
                const lastData = operativities[response.operativities.length - 1];

                const head = emptyOperativities(startDate, (firstData || {} as any).date || endDate, granularity);

                const tail = emptyOperativities((lastData || {} as any).date || startDate, endDate, granularity);

                res({
                    ...response,
                    operativities: [
                        ...head.slice(0, firstData ? -1 : 0),
                        ...operativities, ...tail.slice(lastData ? 1 : 0),
                    ],
                } as any);
            },
            rej,
        );
    });
}

export async function getTotal(filterGuid: string, startDate: Date, endDate: Date)
    : Promise<OperativityTotals> {
    return new Promise((res, rej) => {
        RestDataLoader.loadData(
            "equipment/filters/" + filterGuid + "/operativity/total",
            {
                startDate: dateToLocalISO(startDate),
                endDate: dateToLocalISO(endDate),
            },
            (r: OperativityTotals) => {
                res(r);
            },
            rej,
        );
    });
}

export async function getReport(
    filterGuid: string,
    startDate: Date,
    endDate: Date,
    granularity: GranularityType,
): Promise<void> {
    return new Promise((res, rej) => {
        RestDataLoader.downloadSpreadsheetKeepingFileName(
            "equipment/filters/" + filterGuid + "/operativity/report",
            {
                startDate: dateToLocalISO(startDate),
                endDate: dateToLocalISO(endDate),
                granularity: granularityNames[granularity],
            },
            res,
            rej,
        );
    });
}
